




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { App } from '@/models'

// app_id is the varchar(255) PK, admin-provided: lowercase letters, digits, '-' and '_'.
const APP_ID_REGEX = /^[a-z0-9][a-z0-9_-]*$/

function emptyForm(): App {
  return { appId: '', name: '' }
}

@Component
export default class UpsertAppModal extends Vue {
  @Prop({ required: false }) app: App | null

  private form: App = emptyForm()
  private saving = false

  @Watch('app', { deep: true })
  onAppChanged() {
    this.form = this.app ? { ...this.app } : emptyForm()
  }

  get isNew(): boolean {
    return this.app == null
  }

  // null = neutral (empty); true/false drive the validation styling.
  get appIdState(): boolean | null {
    if (!this.form.appId) return null
    return APP_ID_REGEX.test(this.form.appId)
  }

  private formOk(): boolean {
    if (!this.form.appId || !this.form.name || !this.form.name.trim()) return false
    return APP_ID_REGEX.test(this.form.appId)
  }

  hideModal() {
    this.$bvModal.hide('UpsertAppModal')
  }

  private saveForm(): void {
    if (!this.formOk() || this.saving) return

    const payload: App = {
      appId: this.form.appId.trim().toLowerCase(),
      name: this.form.name.trim()
    }

    const promise = this.isNew
      ? ApiClient.createApp(payload)
      : ApiClient.updateApp(payload.appId, payload)

    this.saving = true
    promise
      .then((saved: App) => {
        this.$emit('appSaved', saved)
        this.hideModal()
        this.form = emptyForm()
      })
      .catch((ex: Error) => {
        this.$bvToast.toast(ex.message, {
          title: this.$t('feedback.error_title_generic').toString(),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.saving = false
      })
  }
}
